"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiTextButton = void 0;
const callable_1 = require("client/components/ui/callable");
const react_1 = require("react");
const React = require("react");
require("./text-button.less");
class UiTextButton extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            callable_1.callable(this.props.onClick)(event);
        };
    }
    render() {
        const { className = "", disabled, primary, secondary } = this.props;
        const primaryClass = primary ? "ui-text-button--primary" : "";
        const secondaryClass = secondary ? "ui-text-button--secondary" : "";
        const disabledClass = disabled ? "ui-text-button--disabled" : "";
        return (React.createElement("a", { className: `ui-text-button ${primaryClass} ${secondaryClass} ${disabledClass} ${className}`, onClick: this.handleClick }, this.props.children));
    }
}
exports.UiTextButton = UiTextButton;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/text-button/text-button.tsx
// module id = 3619
// module chunks = 0